if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        // Remove keyboard listener when modal closes
        if (this._onKeydown) {
          document.removeEventListener('keydown', this._onKeydown);
          this._onKeydown = null;
        }
        // After closing, ensure active product media uses cover and is centered to prevent bottom alignment jump
        requestAnimationFrame(() => {
          document
            .querySelectorAll(
              '.product__media-list .product-media-container .media > img, .product__media-list .product-media-container picture > img'
            )
            .forEach((img) => {
              img.style.objectFit = 'cover';
              img.style.objectPosition = 'center center';
            });
        });
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();

        // Initialize counter and nav
        const items = Array.from(
          this.querySelectorAll('.product-media-modal__content > [data-media-id]')
        );
        const counter = this.querySelector('.product-media-modal__counter');
        const btnPrev = this.querySelector('.product-media-modal__nav--prev');
        const btnNext = this.querySelector('.product-media-modal__nav--next');
        const updateCounter = () => {
          const activeIdx = items.findIndex((el) => el.classList.contains('active'));
          if (counter && activeIdx >= 0) counter.textContent = `${activeIdx + 1}/${items.length}`;
        };
        updateCounter();

        const goTo = (dir) => {
          const currentIndex = items.findIndex((el) => el.classList.contains('active'));
          if (currentIndex < 0) return;
          let nextIndex = (currentIndex + dir + items.length) % items.length;
          items[currentIndex].classList.remove('active');
          items[nextIndex].classList.add('active');
          items[nextIndex].scrollIntoView({ block: 'center' });
          updateCounter();
        };

        const stop = (e) => {
          e.preventDefault();
          e.stopPropagation();
        };
        btnPrev?.addEventListener('click', (e) => { stop(e); goTo(-1); }, { once: false });
        btnNext?.addEventListener('click', (e) => { stop(e); goTo(1); }, { once: false });

        // Thumbnails navigation (desktop)
        const thumbs = Array.from(this.querySelectorAll('.product-media-modal__thumb'));
        const syncThumbs = () => {
          const active = this.querySelector('.product-media-modal__content > [data-media-id].active');
          const id = active?.getAttribute('data-media-id');
          thumbs.forEach((t) => t.setAttribute('aria-current', t.getAttribute('data-media-id') === id ? 'true' : 'false'));
        };
        thumbs.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const id = btn.getAttribute('data-media-id');
            const current = this.querySelector('.product-media-modal__content > [data-media-id].active');
            const target = this.querySelector(`.product-media-modal__content > [data-media-id="${id}"]`);
            if (!target || target === current) return;
            current?.classList.remove('active');
            target.classList.add('active');
            target.scrollIntoView({ block: 'center' });
            updateCounter();
            syncThumbs();
          });
        });

        // Keep thumbnails in sync on arrow navigation
        const observer = new MutationObserver(syncThumbs);
        items.forEach((el) => observer.observe(el, { attributes: true, attributeFilter: ['class'] }));
        syncThumbs();

        // Keyboard navigation (left/right arrows)
        this._onKeydown = (e) => {
          const tag = (e.target && e.target.tagName) ? e.target.tagName.toLowerCase() : '';
          if (tag === 'input' || tag === 'textarea' || tag === 'select' || e.target?.isContentEditable) return;
          if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(-1); }
          else if (e.key === 'ArrowRight') { e.preventDefault(); goTo(1); }
        };
        document.addEventListener('keydown', this._onKeydown);
      }

      showActiveMedia() {
        this.querySelectorAll('.product-media-modal__content > [data-media-id]')
          .forEach((element) => {
            if (element.getAttribute('data-media-id') !== this.openedBy.getAttribute('data-media-id')) {
              element.classList.remove('active');
            }
          });
        const activeMedia = this.querySelector(
          `.product-media-modal__content > [data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
        );
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
